<template>
  <CustomPage title="我的店铺访客" color="black" bgcolor="white">
    <div slot="content" style="height: 100%">
      <div
        class="
          flex
          items-center
          van-hairline--bottom
          p-3
          border-t border-red-600
        "
      >
        <div class="mr-2" style="height: 34px; width: 34px">
          <img
            class="w-full h-full rounded-full"
            src="https://img01.yzcdn.cn/vant/cat.jpeg"
            alt=""
          />
        </div>
        <div class="flex-grow">
          <div class="flex">
            <span class="text-xs mr-1">ERNEST</span
            ><span class="text-xxs text-red mr-1">联系ta</span
            ><img src="@/assets/store/联系ta.svg" alt="" />
          </div>
          <div class="text-xs">ID:123456</div>
        </div>
      </div>
      <div
        class="flex justify-between text-xs mx-3 mb-3"
        style="color: #666666"
      >
        <div
          class="rounded-full px-2"
          @click="activeTab = 0"
          :class="activeTab === 0 ? 'active' : ''"
        >
          今日
        </div>
        <div
          class="rounded-full px-2"
          @click="activeTab = 1"
          :class="activeTab === 1 ? 'active' : ''"
        >
          昨日
        </div>
        <div
          class="rounded-full px-2"
          @click="activeTab = 2"
          :class="activeTab === 2 ? 'active' : ''"
        >
          近7日
        </div>
        <div
          class="rounded-full px-2"
          @click="activeTab = 3"
          :class="activeTab === 3 ? 'active' : ''"
        >
          近30日
        </div>
        <Popover
          :offset="[0, 0]"
          v-model="showPopover"
          trigger="click"
          :actions="actions"
          @select="onSelect"
        >
          <template #reference>
            <div :class="activeTab === 5 ? 'font-semibold' : ''">
              {{ selectedAction
              }}<Icon class="transform rotate-90" name="play" color="#E82035" />
            </div>
          </template>
        </Popover>
      </div>
      <Tabs v-model="activeSort">
        <Tab title="商品"><GoodsList /></Tab>
        <Tab title="会场"
          ><div
            v-for="item in [{}, {}, {}, {}, {}]"
            :key="item.partId"
            class="rounded-lg lightshadow p-2 m-3"
            @click="
              $router.push({
                name: 'BrandPlace',
                params: { partId: item.partId },
                query: {
                  actId: item.actId,
                  brandLogo: item.brandLogo,
                },
              })
            "
          >
            <div class="flex items-center py-3">
              <div style="height: 44px; width: 44px" class="flex-shrink-0">
                <img
                  class="h-full w-full rounded-lg"
                  :src="item.brandLogo"
                  alt=""
                />
              </div>
              <div class="flex-grow mx-2" style="max-width: 60%">
                <div
                  class="text-left font-semibold overflow-x-scroll"
                  style="white-space: nowrap"
                >
                  <span class="text-base"> {{ item.brandName }} </span
                  ><span class="text-xs" style="white-space: nowrap">{{
                    item.actName
                  }}</span>
                </div>
                <div class="flex flex-row flex-no-wrap overflow-x-scroll h-5">
                  <span
                    class="text-xxs text-red border-red1px rounded px-1 mr-1"
                    style="white-space: nowrap; line-height: 1.125rem"
                    >共{{ item.actGoodsList }}款</span
                  >
                  <span
                    v-for="i in item.partServiceList"
                    :key="i.id"
                    class="text-xxs text-red border-red1px rounded px-1 mr-1"
                    style="white-space: nowrap; line-height: 1.125rem"
                    >{{ i.name }}</span
                  >
                </div>
              </div>
              <div
                class="
                  text-white
                  rounded-full
                  flex flex-row
                  items-center
                  pr-1
                  pl-2
                  justify-end
                  flex-shrink-0
                "
                style="
                  background-color: #e82035;
                  padding-top: 0.1rem;
                  padding-bottom: 0.1rem;
                "
              >
                <span class="text-xs">进入会场</span
                ><Icon name="arrow" class="ml-1" />
              </div>
            </div>
            <div class="flex justify-start">
              <div
                v-for="i in item.actGoodsList"
                :key="i.goodsId"
                class="relative mr-2"
                style="width: 50px; height: 50px"
              >
                <img
                  :src="i.goodsImage"
                  class="absolute h-full w-full rounded-full top-0 left-0"
                  style="object-fit: cover"
                />
              </div>
              <div
                class="relative rounded-full"
                style="width: 50px; height: 50px; background-color: #f5f5f5"
              >
                <div class="absolute text-xxs font-light" style="top: 35%">
                  查看更多...
                </div>
              </div>
            </div>
          </div></Tab
        >
      </Tabs>
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from '@/components/custom-page.vue'
import GoodsList from './components/GoodsList.vue'
import { Popover, Icon, Tab, Tabs } from 'vant'
export default {
  components: { CustomPage, GoodsList, Popover, Icon, Tab, Tabs },
  created() {},
  data() {
    return {
      activeTab: 0,
      activeSort: 0,
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      currentYear: this.dayjs().year(),
      currentMonth: this.dayjs().month() + 1,
      selectedAction: this.dayjs().format('YYYY-MM'),
    }
  },
  methods: {
    onSelect(action) {
      this.activeTab = 5
      this.selectedAction = action.text
    },
  },
  computed: {
    actions() {
      let temp = []
      for (let i = 0; i < 12; i++) {
        if (this.currentMonth > i) {
          temp.push({
            text: this.dayjs(
              this.currentYear + '-' + (this.currentMonth - i)
            ).format('YYYY-MM'),
          })
        } else {
          temp.push({
            text: this.dayjs(
              this.currentYear - 1 + '-' + (this.currentMonth - i + 12)
            ).format('YYYY-MM'),
          })
        }
      }

      return temp
    },
  },
}
</script>

<style lang="less" scoped>
.active {
  background-color: #e82035;
  color: white;
}
::v-deep .van-tab--active {
  font-weight: 600;
  color: #e82035;
}
</style>
